import React from 'react';
import { DocsMenuScopeGroup } from './DocsMenuScopeGroup';

export const DocsMenuList = (props) => {
  return (
    <div>
      <DocsMenuScopeGroup
        rpcListAll={props.rpcListAll}
        rpcScopeProcedure={props.rpcScopeProcedure}
      />
    </div>
  );
};
